function canUseStorage () {
  try {
    return typeof window !== 'undefined' && !!window.localStorage
  } catch (e) {
    return false
  }
}

export const storage = {
  get (key, fallback = '') {
    if (!canUseStorage()) return fallback
    try {
      const v = window.localStorage.getItem(key)
      return v == null ? fallback : v
    } catch (e) {
      return fallback
    }
  },
  set (key, value) {
    if (!canUseStorage()) return
    try {
      window.localStorage.setItem(key, String(value))
    } catch (e) {}
  },
  remove (key) {
    if (!canUseStorage()) return
    try {
      window.localStorage.removeItem(key)
    } catch (e) {}
  },
  getJSON (key, fallback = null) {
    const v = storage.get(key, '')
    if (!v) return fallback
    try {
      return JSON.parse(v)
    } catch (e) {
      return fallback
    }
  },
  setJSON (key, value) {
    try {
      storage.set(key, JSON.stringify(value))
    } catch (e) {}
  }
}




// WEBPACK FOOTER //
// ./src/utils/storage.js